// extracted by mini-css-extract-plugin
export default {"Card":"index__Card--8XMiW","card":"index__Card--8XMiW","CardHorizontal":"index__CardHorizontal--7bl+P","cardHorizontal":"index__CardHorizontal--7bl+P"};